export const FIREBASE_CONFIG = {
    apiKey: "AIzaSyAlqHgpApitkWMVt5WlDL3Ire2zoJOFKgA",
    authDomain: "kukai-db.firebaseapp.com",
    projectId: "kukai-db",
    storageBucket: "kukai-db.appspot.com",
    messagingSenderId: "684382402272",
    appId: "1:684382402272:web:80fccee4d1e317036cc285"
}
